module.exports = __webpack_public_path__ + "img/GOVERNANCA-CORPORATIVA-thumb.d2a08436.png";